import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-46",
  "use": "icon-sheet_icon-46-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-46\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\".75\" y=\".75\" width=\"16.5\" height=\"18.5\" rx=\"2\" transform=\"translate(3 2)\" /><path stroke-linecap=\"round\" d=\"M9 8l3 3M15 8l-3 3M9 14.5h6M9 11.5h6M12 11.4v6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol